module.exports = __webpack_public_path__ + "images/d8af8e7.png";